import React, { useEffect } from 'react';
import { FaWhatsapp, FaTimes, FaHeart, FaStar, FaCheck } from 'react-icons/fa';
import { generateWhatsAppLink } from '../data/products';

const ProductModal = ({ product, onClose }) => {
    const whatsappLink = generateWhatsAppLink(product.name, product.price);

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = 'auto'; };
    }, []);

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) onClose();
    };

    return (
        <div className="modal-overlay" onClick={handleOverlayClick}>
            <div className="modal-content relative">
                <button onClick={onClose} className="absolute top-4 right-4 z-10 bg-white/90 p-2 rounded-full shadow-lg hover:bg-dulce-pink-100 transition-all duration-300 hover:rotate-90">
                    <FaTimes className="text-gray-600" size={20} />
                </button>

                <div className="grid md:grid-cols-2 gap-0">
                    <div className="relative overflow-hidden rounded-t-3xl md:rounded-l-3xl md:rounded-tr-none">
                        <img src={product.image} alt={product.name} className="w-full h-72 md:h-full object-cover" />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
                        <div className="absolute bottom-4 left-4">
                            <div className={`${product.badgeColor} text-white px-5 py-3 rounded-2xl shadow-lg`}>
                                <span className="text-xs">Precio especial</span>
                                <span className="block text-3xl font-bold">${product.price}</span>
                                <span className="text-xs">pesos</span>
                            </div>
                        </div>
                        <div className="absolute top-4 left-4">
                            <button className="bg-white/80 p-3 rounded-full shadow-md">
                                <FaHeart className="text-dulce-pink-500 animate-heart-beat" size={20} />
                            </button>
                        </div>
                    </div>

                    <div className={`p-6 md:p-8 bg-gradient-to-b ${product.bgGradient}`}>
                        <span className={`inline-block ${product.badgeColor} text-white text-xs font-semibold px-3 py-1 rounded-full mb-4`}>
                            Hecho con amor 💕
                        </span>

                        <h2 className={`font-playfair text-3xl md:text-4xl font-bold ${product.accentColor} mb-2`}>{product.name}</h2>

                        <div className="flex items-center gap-2 mb-4">
                            <div className="flex gap-0.5">
                                {[...Array(5)].map((_, i) => <FaStar key={i} className="text-amber-400" size={16} />)}
                            </div>
                            <span className="text-sm text-gray-500">(5.0)</span>
                        </div>

                        <p className="text-gray-600 text-base leading-relaxed mb-6">{product.longDescription}</p>

                        <div className="space-y-3 mb-6">
                            <h4 className="font-semibold text-gray-800 text-sm uppercase tracking-wider">Características</h4>
                            {product.features.map((feature, i) => (
                                <div key={i} className="flex items-center gap-3">
                                    <div className={`w-6 h-6 rounded-full ${product.badgeColor} flex items-center justify-center flex-shrink-0`}>
                                        <FaCheck className="text-white" size={10} />
                                    </div>
                                    <span className="text-gray-700 text-sm">{feature}</span>
                                </div>
                            ))}
                        </div>

                        <div className={`bg-white/60 rounded-xl p-4 mb-6 border ${product.borderColor}`}>
                            <p className="text-sm text-gray-600">
                                🕐 <strong>Pedidos con 24 horas de anticipación.</strong><br />
                                📍 Ideal para reuniones familiares, celebraciones o darte un gusto.
                            </p>
                        </div>

                        <a href={whatsappLink} target="_blank" rel="noopener noreferrer"
                            className="w-full inline-flex items-center justify-center gap-3 bg-green-500 hover:bg-green-600 text-white font-bold py-4 px-6 rounded-2xl shadow-lg transform hover:scale-[1.02] transition-all duration-300 text-lg">
                            <FaWhatsapp size={22} />
                            <span>¡Pedir Ahora!</span>
                        </a>

                        <p className="text-center text-xs text-gray-400 mt-3">
                            💬 Te respondemos rápidamente por WhatsApp
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductModal;